import LegalPage from "@/components/legal/LegalPage";
import { legalPolicies } from "@/src/content/legalPolicies";

export default function RefundPolicyPage() {
  return <LegalPage policy={legalPolicies.refundPolicy} />;
}
